import { categories } from "@/mocks/mangaData";

const quickLinks = [
  { label: "首页", href: "#home" },
  { label: "本命推荐", href: "#recommend" },
  { label: "分类推荐", href: "#category" },
  { label: "入坑指南", href: "#guide" },
  { label: "热门排行", href: "#rank" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a href="#home" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">131漫画网</span>
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              按本命标准挑出入坑作，从画风到剧情都是能当本命的存在。一生推的入坑作都在这里。
            </p>
          </div>

          <div>
            <h4 className="font-display text-base text-foreground-950 mb-3">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base text-foreground-950 mb-3">推荐分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <a href="#category" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base text-foreground-950 mb-3">联系我们</h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                hello@131mh.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-2-line text-primary-600"></i>
                131漫画网
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-bilibili-fill text-primary-600"></i>
                @131漫画网
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 131漫画网 · 本命推荐入坑作指南，找到你的新本命
          </p>
          <p className="text-xs text-foreground-500">一生推，入坑不踩雷</p>
        </div>
      </div>
    </footer>
  );
}